<script setup>
const { id } = defineProps({
  id: String,
});
const route = useRoute();

const { data: sessionData, getSession, status } = useAuth();
const toast = useToast();

// const { data: userWishlists } = useApiFetch("wishlists", {
//   method: "GET",
//   transform(userWishlists) {
//     return userWishlists?.data;
//   },
// });

const uniWishlists = computed(() => {
  return sessionData?.value?.data?.wishlists
    ?.filter((w) => w.university)
    ?.map((w) => w?.university?.id);
});

const programWishlists = computed(() => {
  return sessionData?.value?.data?.wishlists
    ?.filter((w) => w.program)
    ?.map((w) => w.program?.id);
});

const isWishlisted = computed(() => {
  return (
    uniWishlists.value?.includes(id) || programWishlists.value?.includes(id)
  );
});

const addWishlist = async () => {
  await useApiFetch("wishlists", {
    method: "POST",
    body: {
      entity_id: id,
    },
    onResponse() {
      refreshNuxtData("program-wishlists");
      getSession();
      toast.add({
        severity: "success",
        summary: "Added to wishlist.",
        life: 3000,
      });
    },
  });
};

const removeWishlist = async () => {
  let wishlistId = null;
  if (uniWishlists.value?.includes(id)) {
    wishlistId = sessionData?.value?.data?.wishlists?.find(
      (w) => w?.university?.id === id,
    )?.id;
  } else {
    wishlistId = sessionData?.value?.data?.wishlists?.find(
      (w) => w?.program?.id === id,
    )?.id;
  }

  await useApiFetch(`wishlists/${wishlistId}`, {
    method: "DELETE",
    onResponse() {
      refreshNuxtData("program-wishlists");
      getSession();
      toast.add({
        severity: "success",
        summary: "Remove from wishlist.",
        life: 3000,
      });
    },
  });
};

const toggleWishlist = async () => {
  if (status.value !== "authenticated") return;
  if (isWishlisted.value) {
    await removeWishlist();
  } else {
    await addWishlist();
  }
};

const showFull = computed(() => {
  return route.name.includes("programs-programSlug");
});
</script>

<template>
  <ProfileCompleteGuard @onCallback="toggleWishlist">
    <span v-if="showFull">
      <Button
        :icon="isWishlisted ? 'pi pi-heart-fill' : 'pi pi-heart'"
        label="Wishlist"
        class="hidden md:flex text-[#1C477B] !text-sm items-center"
        text
        @click="toggleWishlist"
      />
      <Button
        :icon="isWishlisted ? 'pi pi-heart-fill' : 'pi pi-heart'"
        label="Wishlist"
        severity="secondary"
        size="small"
        @click="toggleWishlist"
        class="flex md:hidden py-2"
      />
    </span>
    <span v-else>
      <Button
        :icon="isWishlisted ? 'pi pi-heart-fill' : 'pi pi-heart'"
        label="Wishlist"
        class="hidden md:flex text-[#1C477B] !text-sm items-center"
        text
        @click="toggleWishlist"
      />
      <Button
        :icon="isWishlisted ? 'pi pi-heart-fill' : 'pi pi-heart'"
        text
        size="small"
        @click="toggleWishlist"
        class="flex md:hidden"
      />
    </span>
  </ProfileCompleteGuard>
</template>
